import React, { Fragment, PureComponent } from 'react';
import { pagesApi } from '../../apis/PagesApi';
import IconNext from '../../assets/icons/IconNext';
import IconPrev from '../../assets/icons/IconPrev';
import PageEditor from '../../components_admin/Components/PageEditor/PageEditor';

class AwardsPages extends PureComponent {
   state = {
      content: null,

      loading: true,
   }

   componentDidMount() {
      this.loadData();
   }

   loadData = async () => {
      const response = await pagesApi.getPageAwards();
      if (response && response.id) {
         this.setState({
            content: response.content || null,
            loading: false,
         });
      }
   }

   render() {
      return (
         <div className="pages-list">
            <div className="pages-container">
               {
                  !this.state.loading &&
                  <div className={`outline-box`}>
                     <PageEditor
                        value={this.state.content}
                        readOnly
                     />
                  </div>
               }
            </div>
         </div>
      );
   }
}

export default AwardsPages;